<template>
    <b-button-toolbar justify>
      <b-dropdown
        class="motw-ddown-search font-weight-bold"
        variant="disabled"
        :text="in_search">
            <b-dropdown-item @click="in_search='Authors';options=[];ph=''">Authors</b-dropdown-item>
            <b-dropdown-item @click="in_search='Titles';options=[];ph=''">Titles</b-dropdown-item>
            <b-dropdown-item @click="in_search='Tags';options=[];ph=''">Tags</b-dropdown-item>
        </b-dropdown>
        <b-col>
          <v-select class="vselect motw-ddown-search"
                    ref="searchBar"
                    @input="atInput($event)"
                    :debounce="250"
                    :on-search="getOptions"
                    @on-change="getQuery($event)"
                    :options="options"
                    maxHeight="18em"
                    :placeholder="ph">
          </v-select>
        </b-col>
        <b-button
          variant="link"
          @click="search"
          class="search font-weight-bold motw-ddown shadow-none">SEARCH</b-button>
    </b-button-toolbar>
</template>

<script>
    import vSelect from "vue-select";
    import {
        eventBus
    } from '../main';

    export default {
        data() {
            return {
                options: [],
                query: "",
                categories: {
                    'authors': new Set(),
                    'titles': new Set(),
                    'tags': new Set()
                },
                in_search: "Authors",
                ph: "Search MotW"
            }
        },
        methods: {
            search() {
                if (this.query == "") {
                    return
                }

                if (this.in_search == null) {
                    this.in_search = "";
                }

                this.$store.state.searchQuery = {
                    'endpoint': `/search/${this.in_search.toLowerCase()}/${this.query.toLowerCase()}`,
                    'status': `${this.in_search.toLowerCase()}: ${this.query.toLowerCase()}`
                }
                this.query = "";
                eventBus.$emit('reloadSearch')
            },
            atInput(e) {
                if (e == null) {
                    return
                }

                if (this.in_search == null) {
                    this.in_search = "";
                }

                this.$store.state.searchQuery = {
                    'endpoint': `/search/${this.in_search.toLowerCase()}/${e}`,
                    'status': `${this.in_search.toLowerCase()}: ${e}`
                }
                // this.query = "";
                this.$refs.searchBar.clearSelection();
                eventBus.$emit('reloadSearch')
            },
            getOptions(search, loading) {
                this.query = search;
                this.options = Array.from(this.categories[this.in_search.toLowerCase()]);
                this.options.sort()
                this.options.unshift(this.query.toLowerCase())
                if (search.length != 4) {
                    loading(false)
                    return
                }
                loading(true)
                this.$http.get(
                        `autocomplete/${this.in_search.toLowerCase()}/${search.toLowerCase()}`
                    )
                    .then(response => {
                        let data = response.data
                        let c = this.in_search.toLowerCase()
                        for (let d of data._items) {
                            this.categories[c].add(d)
                        }
                        this.options = Array.from(this.categories[c]);
                        this.options.sort();
                        this.options.unshift(this.query.toLowerCase())
                        loading(false)
                    });
            }
        },
        components: {
            vSelect
        }
    }
</script>

<style scoped>
    .col,
    .v-select {
        display: block;
        width: 100%;
        padding-right: 0px;
        padding-left: 0px;
    }

    .search {
        font-size: 1.1em;
    }
</style>



// WEBPACK FOOTER //
// src/components/SearchBar.vue